/**
   * This contains the map of workflow nodes to wizard steps that are available for the pre-reg/e-reg workflow
   */
  module.exports = {
    'demographics' : 'PROFILE',
    'insurance': 'INSURANCE',
    'questionnaire': 'SURVEYS',
    'form': 'FORMS',
    'financial': 'PAYMENT'
  };
